export default "__VITE_ASSET__e1a60623__"